const fnCmp =
  ({key, desc = false}) =>
  (p1, p2) => {
    const k1 = p1[key];
    const k2 = p2[key];
    // 特殊處理 order 為 0 的情況，0 要排在最後面
    if (key === 'order') {
      if (k1 === 0) return 1;
      if (k2 === 0) return -1;
    }

    const factor = desc ? -1 : 1;
    if (k1 === k2) {
      return 0;
    } else if (k1 > k2) {
      return 1 * factor;
    } else {
      return -1 * factor;
    }
  };

export default fnCmp;
